<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="tutorialsData">
    <div v-if="tutorialsData.code === 500" class="cms-error">
      <span>{{ $t('not_cms') }}</span>
    </div>
    <div v-else class="tutorial-page has-side-bars">
      <h4>{{ $t('head_help') }}</h4>
      <div class="page-wrap">
        <TutorialTreeMenu :tutorials-data="tutorialsData" :selected-tuto="defaultTuto" @change-default-tuto="(tut) => changeDefaultTuto(tut)" />
        <TutorialView :tutorials-data="tutorialsData" :selected-tuto="defaultTuto" />
      </div>
    </div>
  </div>
  <div v-else class="loader">
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import { vCmsHtml as cms, getCMSTutorials } from '@/services/graphql'
import TutorialTreeMenu from '../components/tutorials/TutorialTreeMenu.vue'
import TutorialView from '../components/tutorials/TutorialView.vue'
import Loader from '../components/Loader.vue'

export default {
  components: { Loader, TutorialTreeMenu, TutorialView },
  directives: { cms },
  props: {},
  data() {
    return {
      defaultTuto: {
        folder: null,
        option: '',
      }
    }
  },
  asyncComputed: {
    tutorialsData() {
      return getCMSTutorials(this.$store.state.i18n.lang)
    },
  },
  watch: {
    tutorialsData() {
      if(this.$route.params.params) {
        let folderOp = this.tutorialsData.find(el => el.options.find(x => x.name === this.$route.params.params)).name
        this.defaultTuto = {
          folder: folderOp,
          option: this.$route.params.params
        }
      }
      else {
        this.defaultTuto = {
          folder: this.tutorialsData[0].name,
          option: this.tutorialsData[0].options[0].name
        }
      }
    },
  },
  methods: {
    changeDefaultTuto(tut) {
      if (this.$route.params.params !== tut.option) {
        this.$router.push({ name: 'Help', params: { params: tut.option }})
      }
      this.defaultTuto = tut
    },
  },
}
</script>

<style lang="stylus" scoped>
.tutorial-page
  display: flex
  flex-direction: column
  margin-top: vw(30px)
  margin-bottom: vw(20px)
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
  gap: vw(6px)

  h4
    m-font-size(32, 40)
    font-weight: 600
    margin-block-end: vw(30px)
    margin-block-start: vw(10px)

  .page-wrap
    display: flex
    width: 100%
    gap: vw(15px)

    .mobile &
      flex-direction: column

.cms-error
  display: flex
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400
    
.loader
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
</style>
